import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { auth } from '../firebase/firebaseConfig';
import { signOut } from 'firebase/auth';
import { useNotifications } from '../hooks/useNotifications';
import { useTheme } from '../context/ThemeContext';
import './Navbar.css';

function Navbar() {
  const { currentUser, userProfile } = useAuth();
  const { unreadCount } = useNotifications();
  const { theme, setTheme, resolvedTheme } = useTheme();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      setIsOpen(false);
      navigate('/');
    } catch(err) {
      console.error("Logout failed", err);
    }
  };

  const closeMenu = () => setIsOpen(false);

  return (
    <nav className="navbar">
      <div className="container nav-container">
        <Link to="/" className="nav-logo" onClick={closeMenu}>
          <i className="fa-solid fa-code-merge" style={{color: 'var(--brand-accent)'}}></i>
          DevTracker
        </Link>
        
        <div className="hamburger" onClick={() => setIsOpen(!isOpen)}>
          <i className={`fa-solid ${isOpen ? 'fa-xmark' : 'fa-bars'}`}></i>
        </div>

        <div className={`nav-links ${isOpen ? 'active' : ''}`}>
          <Link to="/" onClick={closeMenu}>Home</Link>
          <Link to="/about" onClick={closeMenu}>About</Link>
          <Link to="/docs" onClick={closeMenu}>Documentation</Link>
          <Link to="/changelog" onClick={closeMenu}>Changelog</Link>
          <Link to="/contact" onClick={closeMenu}>Contact</Link>
          
          <div className="nav-divider"></div>
          
          {!currentUser ? (
            <>
              <Link to="/login" className="btn btn-secondary" onClick={closeMenu}>Login</Link>
              <Link to="/register" className="btn btn-primary" style={{boxShadow: '0 0 15px rgba(0, 255, 174, 0.3)'}} onClick={closeMenu}>Create Profile</Link>
            </>
          ) : (
            <>
              <Link to="/dashboard" className="nav-link-active" onClick={closeMenu}>Dashboard</Link>
              
              <div className="nav-user-container">
                <div className="nav-avatar-wrapper" onClick={() => setDropdownOpen(!dropdownOpen)}>
                  {userProfile?.avatar ? (
                    <img src={userProfile.avatar} alt="Profile" className="nav-avatar" />
                  ) : (
                    <div className="nav-avatar-placeholder"><i className="fa-solid fa-user"></i></div>
                  )}
                  {unreadCount > 0 && <span className="nav-unread-dot"></span>}
                </div>

                <div className={`nav-user-dropdown glass-card ${dropdownOpen ? 'show' : ''}`}>
                  <div className="dropdown-user-info">
                    <strong>{userProfile?.name || 'Developer'}</strong>
                    <span>{userProfile?.profileId || 'Account'}</span>
                  </div>
                  <button onClick={() => { navigate('/dashboard?tab=settings'); setDropdownOpen(false); closeMenu(); }} className="dropdown-item">
                    <i className="fa-solid fa-gear"></i> Settings
                  </button>
                  <button onClick={() => { navigate('/dashboard?tab=notifications'); setDropdownOpen(false); closeMenu(); }} className="dropdown-item">
                    <i className="fa-solid fa-bell"></i> Notifications {unreadCount > 0 && <span className="dropdown-count-badge">{unreadCount}</span>}
                  </button>
                  <button onClick={() => { navigate('/dashboard?tab=security'); setDropdownOpen(false); closeMenu(); }} className="dropdown-item">
                    <i className="fa-solid fa-shield-halved"></i> Security
                  </button>
                  <button onClick={() => { navigate('/report'); setDropdownOpen(false); closeMenu(); }} className="dropdown-item">
                    <i className="fa-solid fa-flag"></i> Report an Issue
                  </button>
                  <div className="dropdown-divider"></div>
                  
                  <div className="dropdown-theme-switcher">
                    <p className="theme-label">Display Mode</p>
                    <div className="theme-buttons">
                      <button 
                        onClick={() => setTheme('light')} 
                        className={`theme-btn ${theme === 'light' ? 'active' : ''}`}
                        title="Light Mode"
                      >
                        <i className="fa-solid fa-sun"></i>
                      </button>
                      <button 
                        onClick={() => setTheme('dark')} 
                        className={`theme-btn ${theme === 'dark' ? 'active' : ''}`}
                        title="Dark Mode"
                      >
                        <i className="fa-solid fa-moon"></i>
                      </button>
                      <button 
                        onClick={() => setTheme('system')} 
                        className={`theme-btn ${theme === 'system' ? 'active' : ''}`}
                        title="System Default"
                      >
                        <i className="fa-solid fa-desktop"></i>
                      </button>
                    </div>
                  </div>

                  <div className="dropdown-divider"></div>
                  <button onClick={handleLogout} className="dropdown-item danger">
                    <i className="fa-solid fa-arrow-right-from-bracket"></i> Logout
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
